module.exports = "data:image/gif;base64,R0lGODlhDgAOANUAAAAAAP////w9APA8AOw4AOo5AMsyAPZCCZMpB5QrCf9LEZ8vDP1OFrk5EP9QF8VGHf9gLatSNtxtStBpSOV3VPWBW/uMaNZ4Wv6aef+cfL57ZqR0ZKx6aqx9bo5nW6WBdbyViK2Mgb2bkMm5tKlQONuGbPSrlZR1bKuhnsi8uf///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAACoALAAAAAAOAA4AAAZDQJVwSCwOU6XLZGQclkyZSqQpvGAgjAZVNbE4DouthqIYeLYgicCA2qoeBIRb9Smc5ioSXtXBi0ohcyUKCXMcCRtGQQA7"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/WPPINVAL.gif
// module id = taM5
// module chunks = 0